export const fixAdress = (address: string | undefined) => {
  const formattedWebpage = address && !address.startsWith('http') ? `http://${address}` : address
  return formattedWebpage
}
